
<ng-template [ngIf]="isUpdatingListino">
      <app-loading></app-loading>
</ng-template>
    
<p-steps [model]="pagineModificaListino" [readonly]="true" [activeIndex]="activeIndex" ></p-steps>
    <div class="d-flex mt-2">
        <ng-container [ngSwitch]="activeIndex">
          <ng-container *ngSwitchCase="0">
            <form [formGroup]="modificaListinoForm">
                <div class="grid formgrid p-fluid">
                   <!--  <div class="field mt-2 mb-2 col-12">
                        <label for="azienda" class="font-medium text-900 text-blue-900">IMPRESA</label>
                        <span class="p-input-icon-left">
                            <i class="pi pi-bookmark"></i>
                            <p-dropdown inputId="azienda" [options]="aziende" optionLabel="ragioneSociale" [showClear]="true"
                                placeholder="Scegli l'impresa" formControlName="azienda">
                                <ng-template let-azienda pTemplate="item">
                                    <div class="flex align-items-center">
                                        <div>{{azienda.ragioneSociale | uppercase}}</div>
                                    </div>
                                </ng-template>
                            </p-dropdown>
                        </span>
                    </div> -->
                    <div class="field mt-2 mb-2 col-2">
                        <label for="ita1" class="font-medium text-900 text-blue-600">SCL.1</label>
                        <p-inputNumber mode="currency" inputId="ita1" currency="EUR" locale="it-IT" formControlName="ita1" [styleClass]="'right-align'"> </p-inputNumber>
                    </div>
                    <div class="field mt-2 mb-2 col-2">
                        <label for="ita2" class="font-medium text-900 text-blue-600">SCL.2</label>
                        <p-inputNumber mode="currency" inputId="ita2" currency="EUR" locale="it-IT" formControlName="ita2" [styleClass]="'right-align'"> </p-inputNumber>
                    </div>
                    <div class="field mt-2 mb-2 col-2">
                        <label for="ita3" class="font-medium text-900 text-blue-600">SCL.3</label>
                        <p-inputNumber mode="currency" inputId="ita3" currency="EUR" locale="it-IT" formControlName="ita3" [styleClass]="'right-align'"> </p-inputNumber>
                    </div>
                    <div class="field mt-2 mb-2 col-2">
                        <label for="ita4" class="font-medium text-900 text-blue-600">SCL.4</label>
                        <p-inputNumber mode="currency" inputId="ita4" currency="EUR" locale="it-IT" formControlName="ita4" [styleClass]="'right-align'"> </p-inputNumber>
                    </div>
                    <div class="field mt-2 mb-2 col-2">
                        <label for="ita5" class="font-medium text-900 text-blue-600">SCL.5</label>
                        <p-inputNumber mode="currency" inputId="ita5" currency="EUR" locale="it-IT" formControlName="ita5" [styleClass]="'right-align'"> </p-inputNumber>
                    </div>
                    <div class="field mt-2 mb-2 col-2">
                        <label for="preventivoBaseItalia" class="font-medium text-900 text-blue-600">Preventivo Base</label>
                        <p-inputNumber mode="currency" inputId="preventivoBaseItalia" currency="EUR" locale="it-IT" formControlName="preventivoBaseItalia" [styleClass]="'right-align'"> </p-inputNumber>
                    </div>
                </div> 
            </form>
          </ng-container>
          <ng-container *ngSwitchCase="1">
            <form [formGroup]="modificaListinoForm">
            <div class="grid mt-2 formgrid p-fluid">
                <div class="field mt-2 mb-2 col-2">
                    <label for="liguria1" class="font-medium text-900 text-blue-600">SCL.1</label>
                    <p-inputNumber mode="currency" inputId="liguria1" currency="EUR" locale="it-IT" formControlName="liguria1" [styleClass]="'right-align'"> </p-inputNumber>
                </div>
                <div class="field mt-2 mb-2 col-2">
                    <label for="liguria2" class="font-medium text-900 text-blue-600">SCL.2</label>
                    <p-inputNumber mode="currency" inputId="liguria2" currency="EUR" locale="it-IT" formControlName="liguria2" [styleClass]="'right-align'"> </p-inputNumber>
                </div>
                <div class="field mt-2 mb-2 col-2">
                    <label for="liguria3" class="font-medium text-900 text-blue-600">SCL.3</label>
                    <p-inputNumber mode="currency" inputId="liguria3" currency="EUR" locale="it-IT" formControlName="liguria3" [styleClass]="'right-align'"> </p-inputNumber>
                </div>
                <div class="field mt-2 mb-2 col-2">
                    <label for="liguria4" class="font-medium text-900 text-blue-600">SCL.4</label>
                    <p-inputNumber mode="currency" inputId="liguria4" currency="EUR" locale="it-IT" formControlName="liguria4" [styleClass]="'right-align'"> </p-inputNumber>
                </div>
                <div class="field mt-2 mb-2 col-2">
                    <label for="liguria5" class="font-medium text-900 text-blue-600">SCL.5</label>
                    <p-inputNumber mode="currency" inputId="liguria5" currency="EUR" locale="it-IT" formControlName="liguria5" [styleClass]="'right-align'"> </p-inputNumber>
                </div>
                <div class="field mt-2 mb-2 col-2">
                    <label for="preventivoBaseLiguria" class="font-medium text-900 text-blue-600">Preventivo Base</label>
                    <p-inputNumber mode="currency" inputId="preventivoBaseLiguria" currency="EUR" locale="it-IT" formControlName="preventivoBaseLiguria" [styleClass]="'right-align'"> </p-inputNumber>
                </div>
             </div>
            </form>
          </ng-container>
          <ng-container *ngSwitchCase="2">
            <form [formGroup]="modificaListinoForm">
                <div class="grid mt-2 formgrid p-fluid">
                    <div class="field mt-2 mb-2 col-2">
                        <label for="piemonte1" class="font-medium text-900 text-blue-600">SCL.1</label>
                        <p-inputNumber mode="currency" inputId="piemonte1" currency="EUR" locale="it-IT" formControlName="piemonte1" [styleClass]="'right-align'"> </p-inputNumber>
                    </div>
                    <div class="field mt-2 mb-2 col-2">
                        <label for="piemonte2" class="font-medium text-900 text-blue-600">SCL.2</label>
                        <p-inputNumber mode="currency" inputId="piemonte2" currency="EUR" locale="it-IT" formControlName="piemonte2" [styleClass]="'right-align'"> </p-inputNumber>
                    </div>
                    <div class="field mt-2 mb-2 col-2">
                        <label for="piemonte3" class="font-medium text-900 text-blue-600">SCL.3</label>
                        <p-inputNumber mode="currency" inputId="piemonte3" currency="EUR" locale="it-IT" formControlName="piemonte3" [styleClass]="'right-align'"> </p-inputNumber>
                    </div>
                    <div class="field mt-2 mb-2 col-2">
                        <label for="piemonte4" class="font-medium text-900 text-blue-600">SCL.4</label>
                        <p-inputNumber mode="currency" inputId="piemonte4" currency="EUR" locale="it-IT" formControlName="piemonte4" [styleClass]="'right-align'"> </p-inputNumber>
                    </div>
                    <div class="field mt-2 mb-2 col-2">
                        <label for="piemonte5" class="font-medium text-900 text-blue-600">SCL.5</label>
                        <p-inputNumber mode="currency" inputId="piemonte5" currency="EUR" locale="it-IT" formControlName="piemonte5" [styleClass]="'right-align'"> </p-inputNumber>
                    </div>
                    <div class="field mt-2 mb-2 col-2">
                        <label for="preventivoBasePiemonte" class="font-medium text-900 text-blue-600">Preventivo Base</label>
                        <p-inputNumber mode="currency" inputId="preventivoBasePiemonte" currency="EUR" locale="it-IT" formControlName="preventivoBasePiemonte" [styleClass]="'right-align'"> </p-inputNumber>
                    </div>
                </div>
            </form>
          </ng-container>
          <ng-container *ngSwitchCase="3">
            <form [formGroup]="modificaListinoForm">
                <div class="grid mt-2 formgrid p-fluid">
                    <div class="field mt-2 mb-2 col-2">
                        <label for="sardegna1" class="font-medium text-900 text-blue-600">SCL.1</label>
                        <p-inputNumber mode="currency" inputId="sardegna1" currency="EUR" locale="it-IT" formControlName="sardegna1" [styleClass]="'right-align'"> </p-inputNumber>
                    </div>
                    <div class="field mt-2 mb-2 col-2">
                        <label for="sardegna2" class="font-medium text-900 text-blue-600">SCL.2</label>
                        <p-inputNumber mode="currency" inputId="sardegna2" currency="EUR" locale="it-IT" formControlName="sardegna2" [styleClass]="'right-align'"> </p-inputNumber>
                    </div>
                    <div class="field mt-2 mb-2 col-2">
                        <label for="sardegna3" class="font-medium text-900 text-blue-600">SCL.3</label>
                        <p-inputNumber mode="currency" inputId="sardegna3" currency="EUR" locale="it-IT" formControlName="sardegna3" [styleClass]="'right-align'"> </p-inputNumber>
                    </div>
                    <div class="field mt-2 mb-2 col-2">
                        <label for="sardegna4" class="font-medium text-900 text-blue-600">SCL.4</label>
                        <p-inputNumber mode="currency" inputId="sardegna4" currency="EUR" locale="it-IT" formControlName="sardegna4" [styleClass]="'right-align'"> </p-inputNumber>
                    </div>
                    <div class="field mt-2 mb-2 col-2">
                        <label for="sardegna5" class="font-medium text-900 text-blue-600">SCL.5</label>
                        <p-inputNumber mode="currency" inputId="sardegna5" currency="EUR" locale="it-IT" formControlName="sardegna5" [styleClass]="'right-align'"> </p-inputNumber>
                    </div>
                    <div class="field mt-2 mb-2 col-2">
                        <label for="preventivoBaseSardegna" class="font-medium text-900 text-blue-600">Preventivo Base</label>
                        <p-inputNumber mode="currency" inputId="preventivoBaseSardegna" currency="EUR" locale="it-IT" formControlName="preventivoBaseSardegna" [styleClass]="'right-align'"> </p-inputNumber>
                    </div>
                </div>
            </form>
          </ng-container>
        </ng-container>
        
    </div>




<div class="surface-border border-top-1 opacity-50 mb-3 col-12"></div>

<div class="margin-top-1" style="text-align: center; display: flex; justify-content: center; align-items: center;">
  
  <p-button icon="pi pi-arrow-left" class="p-button-text mr-2" (click)="activeIndex = activeIndex - 1" [disabled]="activeIndex === 0 "></p-button>
   <p-button icon="pi pi-arrow-right" class="p-button-text mr-1" (click)="changePage()" [disabled]="checkNextStep()"></p-button>
   <p-button *ngIf="activeIndex !== pagineModificaListino.length -1" icon="pi pi-check" label="Conferma saltando gli altri STEP"
    class="p-button-text ml-100" styleClass="p-button-success" (click)="conferma(true)" [disabled]="isUpdatingListino || !modificaListinoForm.valid"></p-button>
   <p-button *ngIf="activeIndex === pagineModificaListino.length -1" icon="pi pi-check" label="Conferma"
    class="p-button-text ml-100" styleClass="p-button-success" (click)="conferma(true)" [disabled]="isUpdatingListino"></p-button>
</div>
<p-toast />
<p-confirmDialog /> 